import { createAction, props } from '@ngrx/store';
import { ClubAttachment } from './club-attachment.model';

// fetch 
export const fetchClubAttachmentListData = createAction('[Data] fetch club user list');
export const fetchClubAttachmentListSuccess = createAction('[Data] fetch club user list success', props<{ ClubAttachmentListdata: ClubAttachment[] }>())
export const fetchClubAttachmentListFail = createAction('[Data fetch club user list failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club attachment',
    props<{ clubId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club attachment success', 
    props<{ listData: ClubAttachment[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club attachment failure', 
    props<{ error: string }>()
);


// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club attachment',
    props<{ clubId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club attachment success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club attachment failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club attachment',
);